/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { TextCellModel } from "./TextCellModel";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
import { TypeRegistrar, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TextHeaderCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(TextHeaderCellPresenter, _super);
    function TextHeaderCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(TextHeaderCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: false,
        configurable: true
    });
    TextHeaderCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ay) {
            if (a.a3(TextCellModel.lj)) {
                b.jb = b.ll;
                this.d.cv.setRawText(b.jb);
            }
            if (a.a3(CellModel.gl)) {
                var c = this.d.cp.l;
                if (a.bk) {
                    this.d.cp.l = false;
                }
                this.d.cp.b = a.n;
                if (a.bk) {
                    this.d.cp.l = c;
                }
            }
            if (a.a3(CellModel.gm)) {
                var d = this.d.cp.l;
                if (a.bk) {
                    this.d.cp.l = false;
                }
                this.d.cp.a0 = a.le;
                if (a.bk) {
                    this.d.cp.l = d;
                }
            }
            if (a.a2("IsColumnOptionsEnabled")) {
                var e = b.lu;
                if (e) {
                    e = this.e();
                }
                this.d.cr = e;
                this.d.ct.setRawStyleProperty("display", e ? "inline-block" : "none");
                this.a.b6(a.gu, (a.f3 + a.f5 + a.ek + a.en));
            }
            if (a.a2("SortIndicatorStyle")) {
                this.d.cp.f = b.ls;
            }
            if (a.a2("ColumnOptionsIconAlignment")) {
                this.d.cj = b.lo;
            }
            if (a.a2("ColumnOptionsIconBehavior")) {
                this.d.cl = b.lq;
            }
            if (a.a2("ColumnOptionsIconColor")) {
                this.d.cn.bq = b.l6;
            }
            ContentCellModelHelper.a(this.a.ab, b, this.a.ae, this.d.cv, this.a);
        }
    };
    TextHeaderCellPresenter.prototype.e = function () {
        return TypeRegistrar.isRegistered("IgxGridColumnOptionsComponent");
    };
    TextHeaderCellPresenter.$t = markType(TextHeaderCellPresenter, 'TextHeaderCellPresenter', CellPresenterBase.$);
    return TextHeaderCellPresenter;
}(CellPresenterBase));
export { TextHeaderCellPresenter };
//# sourceMappingURL=TextHeaderCellPresenter.js.map
